module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event5/younite-event-en-c71b29629424a311958f2f6a016d99dc.png";